import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import GroupingFormFeedback from './GroupingFormFeedback'
import GroupingFormFonts from './GroupingFormFont'
import GroupingFormStyle from './GroupingFormStyle'
import type { GroupingFormBrandType, GroupingBrandForms } from './groupingTypes'

const FORM_MAP: GroupingBrandForms = {
  [BrandFormEnum.STYLE]: GroupingFormStyle,
  [BrandFormEnum.FEEDBACK]: GroupingFormFeedback,
  ...GroupingFormFonts,
}

const GroupingFormBrand: GroupingFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(GroupingFormBrand) as typeof GroupingFormBrand
